import React from "react";

const CommonEAPCard = ({ item, onClick }) => {
  return (
    <>
      <div
        onClick={() => onClick(item)}
        className="bg-white border border-slate-300 mt-4 flex flex-col justify-center items-center rounded-xl py-4 cursor-pointer"
      >
        <img
          src={item?.image ?? ""}
          alt={"EAP Provider"}
          className="h-20 md:h-24 w-40 object-contain"
        />
        <h4 className="font-medium text-black text-base md:text-lg mt-4">
          {item?.options[0]?.title ?? ""}
        </h4>
      </div>
    </>
  );
};

export default CommonEAPCard;
